import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { FileItem, FileUploader } from 'ng2-file-upload';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { CustomFileLike } from 'src/app/models/custom-file-like';
import { ArquivoService } from 'src/app/services/arquivo.service';
import { ProcessosJudiciaisOcorrenciaPrazoService } from 'src/app/services/processos-judiciais-ocorrencia-prazo.service';
import { UtilsService } from 'src/app/utils/utils.service';

@Component({
    selector: 'prazo-detalhes',
    templateUrl: './prazo-detalhes.component.html',
    styleUrls: [
        './prazo-detalhes.component.css',
        '../../../../../vendor/styles/pages/dropzone.scss'
    ]
})
export class PrazoDetalhesComponent implements OnInit {

    @Input() prazoId: any;
    @Input() prazoDetalhes: any;

    @Output() changeQuantidade: EventEmitter<number> = new EventEmitter<number>();
    @Output() changeQuantidadeOcultando: EventEmitter<number> = new EventEmitter<number>();
    @Output() changeConcluirPrazo: EventEmitter<boolean> = new EventEmitter<boolean>();

    public prazo: any;

    public loadPrazo: boolean = true;

    public recarregarAoFechar: boolean = true;

    public comentarioDescricao: string;

    public comentarios: any = [];

    public uploader: FileUploader;

    public loadAtach: boolean = false;

    private file: File;

    private files: Array<File> = [];

    constructor(
        public processosJudiciaisOcorrenciaPrazoService: ProcessosJudiciaisOcorrenciaPrazoService,
        private spinner: NgxSpinnerService,
        public toastrService: ToastrService,
        public arquivoService: ArquivoService,
        public utilsService: UtilsService,
    ) { 
        this.uploader = new FileUploader({
            disableMultipart: true, // 'DisableMultipart' must be 'true' for formatDataFunction to be called.
            formatDataFunctionIsAsync: true,
            formatDataFunction: async (item) => {
                return new Promise((resolve, reject) => { });
            }
        });
    }   

    ngOnInit(): void {
        this.buscarTarefa();
    }

    buscarTarefa() {
        this.processosJudiciaisOcorrenciaPrazoService.getById(this.prazoId)
            .subscribe(res => {

                if (res.success) {
                    this.prazo = res.data;
                    console.log(this.prazo);

                    this.loadPrazo = false;

                    this.prazo.quantidadeComentarios = res.data.quantidadeComentarios;

                    this.comentarios = res.data.comentarios;

                    this.changeQuantidade.emit(this.prazo.quantidadeComentarios);
                }
            })
    }

    handleInserirComentarioForm() {

        this.spinner.show();
        this.toastrService.clear();

        let formData: FormData = new FormData();
        formData.append('prazoId', this.prazoId);
        formData.append('comentario', this.comentarioDescricao != undefined ? this.comentarioDescricao : "");
        this.files.forEach(file => {
            formData.append('files', file);
        });        

        this.processosJudiciaisOcorrenciaPrazoService.addComentario(formData)
            .subscribe(res => {
                if (res.success) {
                    this.toastrService.success("Comentário cadastrado.", "Sucesso");

                    this.buscarTarefa();

                    this.comentarioDescricao = "";

                    this.spinner.hide();

                    this.uploader.clearQueue();

                    this.files = [];
                } else {
                    this.toastrService.error("Falha ao adicionar comentário.", "Sucesso");

                    this.spinner.hide();
                }
            }, error => {
                if (error && error.errors) {
                    this.toastrService.error(error.errors[0], 'Atenção', { timeOut: 10000 });
                }
                else {
                    this.toastrService.error('Não foi possível cadastrar o comentário!', 'Atenção', { timeOut: 10000 });
                }
                this.spinner.hide();
            });
    }

    onDrop(files: FileList) {
        for (let i = 0; i < files.length; i++) {
            console.log(files[i]);
            this.files.push(files[i] as File);
        }

        const fileInQueue:any = this.uploader.queue.find(q => q.file.name === files[0].name);
        const newFile = new CustomFileLike(fileInQueue.file);
        fileInQueue.file = newFile;
    }

    handleRemoveFile(item:FileItem){
        console.log(item);
        this.files = this.files.filter(c=>c.name != item.file.name);
        this.uploader.queue = this.uploader.queue.filter(c=>c.file.name != item.file.name);
    }

    handleOcultar() {
        this.changeQuantidadeOcultando.emit(this.prazo.quantidadeComentarios);
    }

    handleDownloadArquivo(arquivo:any){
        this.spinner.show();
        try{
            this.arquivoService.downloadArquivo(arquivo.arquivoId).subscribe(                
                data => {                    
                    if(data.type == 3){
                        this.spinner.hide();                    
                    }
                    this.utilsService.renderDownload(data, arquivo.nomeArquivo as string);
                }
            );
        }catch{
            this.spinner.hide();
            this.toastrService.error('Não foi possível fazer o download do arquivo!', 'Atenção', { timeOut: 10000 });
        }
    }
}
